/**
 * Rezept-Hilfsfunktionen — KI-Kennzeichnung (EU AI Act / DSGVO)
 *
 * content_source Werte:
 *   'ai:system'   → von Strixly generiert (System-Rezepte)
 *   'ai:fridge'   → von Strixly aus Kühlschrank-Scan generiert
 *   'ai:*'        → zukünftige KI-Quellen — Badge greift automatisch
 *   'user:ocr'    → vom User hochgeladen, KI hat ausgelesen
 *   'user:url'    → vom User importiert (URL)
 *   'user:manual' → manuell erfasst
 */

/**
 * Gibt Badge-Text zurück wenn KI-Inhalt, sonst null.
 * @param {string|null} contentSource
 * @returns {string|null}
 */
export function getKiLabel(contentSource) {
  if (!contentSource) return null;
  if (contentSource.startsWith('ai:')) return 'KI-Rezept';
  return null;
}

/**
 * Gibt Tooltip-Text für das KI-Badge zurück.
 * @param {string|null} contentSource
 * @returns {string}
 */
export function getKiTooltip(contentSource) {
  if (!contentSource) return '';
  if (contentSource === 'ai:fridge') return 'Dieses Rezept wurde von Strixly basierend auf deinem Kühlschrankinhalt erstellt.';
  if (contentSource === 'ai:system') return 'Dieses Rezept wurde von Strixly KI erstellt. Zutaten und Mengen eigenständig prüfen.';
  return 'Dieser Inhalt wurde von einer KI erstellt.';
}
